import React from 'react';
import InvertedTheme from './inverted_theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
var withInvertedTheme = Component => {
  return function WithInvertedTheme(props) {
    return ___EmotionJSX(InvertedTheme, null, ___EmotionJSX(Component, props));
  };
};
export default withInvertedTheme;